import { Layout } from './layout'

export * from './layout'

export default Layout